/**
 * Public notice banner configurations
 *
 * This Map stores notice content that can be displayed via URL parameters.
 * Uses Map for O(1) lookup performance.
 *
 * To add a new notice:
 * 1. Add a new entry to the Map with a unique ID and HTML content
 * 2. Use the notice by adding ?notice=YOUR_ID to any URL
 *
 * All IDs should be UPPERCASE to ensure consistency.
 *
 * To generate a unique ID in a terminal, you can use:
 * openssl rand -hex 4 | tr 'a-z' 'A-Z'
 */
export const noticeBanners = new Map<string, string>([
    [
        'A1C5F0G8',
        'This is a demonstration of the <strong>dynamic banner functionality</strong>, triggered by a unique URL parameter. <a href="/contact-us/">Contact Us</a>.',
    ],
    [
        'IS8HLGTT',
        'Welcome to Geotab! You\'ve been redirected here from Verizon Connect Great Britain. We\'re excited to announce that Verizon Connect Great Britain is now part of the Geotab family. Rest assured, the products and services you valued will continue to be supported and enhanced as we integrate our offerings. <a href="https://www.geotab.com/uk/press-release/verizon-connect/">Please read here to learn more.</a>',
    ],
    [
        'CYJ1TKDT',
        'Welcome to Geotab! You\'ve been redirected here from Verizon Connect Ireland. We\'re excited to announce that Verizon Connect Ireland is now part of the Geotab family. Rest assured, the products and services you valued will continue to be supported and enhanced as we integrate our offerings. <a href="https://www.geotab.com/ie/press-release/verizon-connect/">Please read here to learn more.</a>',
    ],
    [
        'F9UB9MVG',
        'Welcome to Geotab! You\'ve been redirected here from Verizon Connect Australia. We\'re excited to announce that Verizon Connect Australia is now part of the Geotab family. Rest assured, the products and services you valued will continue to be supported and enhanced as we integrate our offerings. <a href="https://www.geotab.com/au/press-release/verizon-connect/">Please read here to learn more.</a>',
    ],
    [
        'VHFY6XW1',
        'Willkommen bei Geotab! Sie wurden von Verizon Connect Deutschland hierher weitergeleitet. Wir freuen uns, Ihnen mitteilen zu können, dass Verizon Connect Deutschland jetzt Teil der Geotab-Familie ist. Wir versichern Ihnen: Die von Ihnen geschätzten Produkte und Dienstleistungen werden auch weiterhin unterstützt und im Zuge der Zusammenführung unserer Angebote verbessert. <a href="https://www.geotab.com/de/presse/verizon-connect/">Erfahren Sie hier mehr.</a>',
    ],
    [
        'IHAZW79G',
        'Bienvenue chez Geotab ! Vous avez été redirigé depuis le site de Verizon Connect France. Nous sommes ravis de vous annoncer que Verizon Connect France fait désormais partie de la famille Geotab. Rassurez-vous, les produits et services que vous appréciez continueront d\'être pris en charge et améliorés au fur et à mesure que nous intégrons nos offres. <a href="https://www.geotab.com/fr/espace-presse/verizon-connect/">Pour en savoir plus, veuillez cliquer ici.</a>',
    ],
    [
        '5HBW2JCN',
        'Bem-vindo à Geotab! Foi redirecionado para aqui a partir do Verizon Connect Portugal. Temos todo o gosto em anunciar que o Verizon Connect Portugal agora faz parte da família Geotab. Tenha a certeza de que os produtos e serviços que valorizou continuarão a ser suportados e melhorados à medida que integramos as nossas ofertas.',
    ],
    [
        '4N8RKHWX',
        'Witamy w Geotab! Zostałeś przekierowany tutaj z Verizon Connect Polska. Z przyjemnością informujemy, że Verizon Connect Polska jest teraz częścią rodziny Geotab. Nie martw się, produkty i usługi, które cenisz, będą nadal wspierane i udoskonalane w miarę integrowania naszej oferty.',
    ],
    [
        'LR2JIYOW',
        'Benvenuto in Geotab! Sei stato reindirizzato qui da Verizon Connect Italia. Siamo lieti di annunciare che Verizon Connect Italia è entrata a far parte della famiglia Geotab. Ti garantiamo che i prodotti e i servizi che hai sempre apprezzato continueranno a essere supportati e migliorati, man mano che integriamo le nostre offerte. <a href="https://www.geotab.com/it/comunicati-stampa/verizon-connect/">Per saperne di più, leggi qui.</a>',
    ],
    [
        'GOZPUVTW',
        'Welkom bij Geotab. U bent hier omgeleid vanuit Verizon Connect Nederland. Met trots kondigen we aan dat Verizon Connect Nederland nu deel uitmaakt van de Geotab-familie. Wees gerust, de producten en diensten die u waardeert, zullen blijven worden ondersteund en verbeterd terwijl we ons aanbod integreren. <a href="https://www.geotab.com/nl/persbericht/verizon-connect/">Kijk hier voor meer informatie.</a>',
    ],
]);
